const AUTO_EXCHANGE_PROTOCOL_MAP = {
  ETH: 'ETH',
  'ETH-ERC20': 'ETH',
  BTC: 'BTC',
  Bitcoin: 'BTC'
}

function protocolToShortName(protocol) {
  return AUTO_EXCHANGE_PROTOCOL_MAP[protocol] || ''
}

function shouldAutoExchangeRecharge(protocol) {
  return !!protocolToShortName(protocol)
}

function toPositiveNumber(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const numberValue = Number(value)
  return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : null
}

function getCurrencyId(row) {
  return row && row.Currency ? row.Currency.ID : null
}

function getCurrencyShortName(row) {
  return row && row.Currency && row.Currency.ShortName
    ? String(row.Currency.ShortName).toUpperCase()
    : ''
}

function getTradeCurrencyId(row) {
  return row ? row.CurrencyId || row.currency_id || row.currencyId : null
}

function getTradeShortName(row) {
  if (!row) return ''
  if (row.ShortName) return String(row.ShortName).toUpperCase()
  if (row.Currency && row.Currency.ShortName) {
    return String(row.Currency.ShortName).toUpperCase()
  }
  return ''
}

function findRechargeConversionRate(protocol, walletRows, tradeRows) {
  const shortName = protocolToShortName(protocol)
  if (!shortName) return null

  const normalizedShortName = shortName.toUpperCase()
  const walletRow = (walletRows || []).find((row) => {
    return getCurrencyShortName(row) === normalizedShortName
  })
  const currencyId = getCurrencyId(walletRow)

  const tradeRow = (tradeRows || []).find((row) => {
    if (currencyId && getTradeCurrencyId(row) === currencyId) {
      return true
    }
    return getTradeShortName(row) === normalizedShortName
  })
  const rate = toPositiveNumber(tradeRow && tradeRow.Price)

  return rate
}

function calculateRechargeConversion(amount, rate) {
  const amountNumber = toPositiveNumber(amount)
  const rateNumber = toPositiveNumber(rate)
  if (!amountNumber || !rateNumber) {
    return ''
  }

  return (amountNumber * rateNumber).toFixed(4)
}

module.exports = {
  calculateRechargeConversion,
  findRechargeConversionRate,
  protocolToShortName,
  shouldAutoExchangeRecharge
}
